import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SectionWrapper from '@/components/atoms/SectionWrapper';
import { isHeadlessBrowser } from '@/utils/isHeadlessBrowser';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import * as React from 'react';
import { twMerge } from 'tailwind-merge';
import TileBlockCard from './TileBlockCard';
import TileBlockContent from './TileBlockContent';
gsap.registerPlugin(ScrollTrigger);
const TileBlock = (props) => {
    const { componentID, theme, topPadding, bottomPadding, cardLayout = 'contentOverlap', cardSize = 'sm', items: itemList = [], textAlignment = 'left', background, } = props;
    const itemCount = itemList.length;
    const refContainer = useAnimation();
    const getCardSpan = React.useCallback((index) => {
        // Small cards are three per row so spanning 2 wouldn't help.
        if (cardSize === 'sm') {
            return 1;
        }
        // Even totals are fine.
        if (itemCount % 2 !== 1) {
            return 1;
        }
        // Only change the last card.
        if (index !== itemCount - 1) {
            return 1;
        }
        return 2;
    }, [cardSize, itemCount]);
    return (_jsx(SectionWrapper, { bottomPadding: bottomPadding, className: "text-text-body", theme: theme, background: background, topPadding: topPadding, "data-test-id": "Tile Block-organism", "data-epi-block-id": componentID, children: _jsx("div", { ref: refContainer, "data-show-after-hydration": true, children: textAlignment === 'top' ? (_jsxs("div", { className: "grid gap-x-1.5 gap-y-2", children: [_jsx(TileBlockContent, { ...props }), itemList.length ? (_jsx("div", { className: twMerge('grid grid-flow-row grid-cols-1 gap-x-1.5 gap-y-2 sm:grid-cols-2', cardSize === 'lg' && 'lg:grid-cols-2', cardSize === 'sm' && 'lg:grid-cols-3'), children: itemList.map((item, index) => (_jsx(TileBlockCard, { ...item, cardLayout: cardLayout, cardSize: cardSize, cardSpan: getCardSpan(index) }, item.componentID))) })) : null] })) : (_jsxs("div", { className: twMerge('grid grid-cols-1 items-start gap-x-1.5 gap-y-2', cardSize === 'lg' && 'lg:grid-cols-3', cardSize === 'sm' && 'lg:grid-cols-4'), children: [_jsx(TileBlockContent, { ...props, className: textAlignment === 'right' ? 'lg:order-last' : '' }), _jsx("div", { className: twMerge('grid grid-cols-1 gap-x-1.5 gap-y-2 sm:grid-cols-2', cardSize === 'lg' && 'lg:col-span-2 lg:grid-cols-2', cardSize === 'sm' && 'lg:col-span-3 lg:grid-cols-3'), children: itemList.map((item, index) => (_jsx(TileBlockCard, { ...item, cardLayout: cardLayout, cardSize: cardSize, cardSpan: getCardSpan(index) }, item.componentID))) })] })) }) }));
};
export default TileBlock;
function useAnimation() {
    const refContainer = React.useRef(null);
    useGSAP(() => {
        if (isHeadlessBrowser()) {
            return;
        }
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: refContainer.current,
                start: 'top 80%',
                toggleActions: 'play none none',
            },
        });
        tl.fromTo('[data-stagger]', {
            opacity: 0,
            y: 20,
        }, {
            opacity: 1,
            y: 0,
            duration: 2,
            ease: 'power3.out',
            stagger: {
                each: 0.2,
            },
        }, 0);
        tl.fromTo('[data-fade]', {
            opacity: 0,
        }, {
            opacity: 1,
            duration: 2,
            ease: 'power3.out',
            stagger: {
                each: 0.2,
            },
        }, 0);
    }, { scope: refContainer });
    return refContainer;
}
